import { render, staticRenderFns } from "./onebox-filesbusiness-scrolling.vue?vue&type=template&id=2cb205b9&"
import script from "./onebox-filesbusiness-scrolling.vue?vue&type=script&lang=js&"
export * from "./onebox-filesbusiness-scrolling.vue?vue&type=script&lang=js&"
import style0 from "./onebox-filesbusiness-scrolling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports